<script setup lang="ts">
import { ref, onErrorCaptured } from 'vue'

const hasError = ref(false)

onErrorCaptured(() => {
  hasError.value = true
  return false
})
</script>

<template>
  <div v-if="hasError" class="q-error-boundary">
    <div class="q-error-boundary__content">
      <img src="/img/logo/logo-quatrefeuilles.png" alt="Aux Quatrefeuilles d'Oc" class="q-error-boundary__logo">
      <h1>Oeps! Er ging iets mis.</h1>
      <p>De website is tijdelijk niet beschikbaar. Probeer het later opnieuw.</p>
      <a href="/" class="q-button">Terug naar de homepagina</a>
    </div>
  </div>
  <RouterView v-else />
</template>
